export const HEADER_OFFSET: number = 64;
export const GAP_UNDER_BAR: number = 6;
export const BAR_TOP: number = 20;
export const BAR_HEIGHT: number = 76;
export const LEFT_OFFSET: number = 3;
export const WIDTH_OFFSET: number = 10;
export const SAFARI_OFFSET: number = 20;
